import React from "react";
import PageLayout from "../../layouts/PageLayout"; // Import template
import Modal from "../modal/Modal"; // Import modal
import "./Error.css";

interface HomeProps {
  config: any;
}

const Error: React.FC<HomeProps> = ({ config }) => {

  return (
    <div className="modal-container">
      <PageLayout isCard={false}>
        {/* Modal will be inside the layout */}
        <Modal
          isOpen={true}
          title="Session Expired"
          message="Check your bank app to decline any pending payment requests.
                 Return to the merchant's page to retry the payment."
        />
      </PageLayout>
    </div>
  );
};

export default Error;
